import axios from 'axios';
import { applyCommonHeaders } from './httpCommon';
import config from '../config';

// UAT: require explicit API base; avoid implicit localhost fallback
const API_BASE_URL = (() => {
  const base = config.VITE_CORE_API_BASE_URL || config.VITE_API_BASE_URL;
  if (!base) {
    throw new Error('VITE_CORE_API_BASE_URL (or VITE_API_BASE_URL) must be set for API calls');
  }
  return base.replace(/\/$/, '');
})();

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth + tenant headers
api.interceptors.request.use(applyCommonHeaders, (error) => Promise.reject(error));

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login on unauthorized
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
